import { createContext } from "react";

export const EdgeClickContext = createContext(null);
